import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	onboardingDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	onboardingHeader: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	onboardingDismiss: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	onboardingDescriptionIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	onboardingHeaderIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	onboardingDescription: {
		id: 'issue-table-inline-issue-create.inline-create-trigger.onboarding.onboarding-description',
		defaultMessage: 'Quickly create issues on this page by selecting + Create below',
		description: 'Description on how to create issues on the jira spreadsheet component.',
	},
	onboardingHeader: {
		id: 'issue-table-inline-issue-create.inline-create-trigger.onboarding.onboarding-header',
		defaultMessage: 'Create issues in context',
		description: 'Header on how to create issues on the jira spreadsheet component.',
	},
	onboardingDismiss: {
		id: 'issue-table-inline-issue-create.inline-create-trigger.onboarding.onboarding-dismiss',
		defaultMessage: 'OK',
		description: 'Label for a button that dismisses a Spotlight.',
	},
	onboardingDescriptionIssueTerminologyRefreshM4: {
		id: 'issue-table-inline-issue-create.inline-create-trigger.onboarding.onboarding-description-issue-terminology-refresh-m4',
		defaultMessage: 'Quickly create work items on this page by selecting + Create below',
		description: 'Description on how to create issues on the jira spreadsheet component.',
	},
	onboardingHeaderIssueTerminologyRefreshM4: {
		id: 'issue-table-inline-issue-create.inline-create-trigger.onboarding.onboarding-header-issue-terminology-refresh-m4',
		defaultMessage: 'Create work items in context',
		description: 'Header on how to create issues on the jira spreadsheet component.',
	},
});
export default messages;
